import { css } from 'styled-components';
var styles = css([".map-wrapper{width:100%;height:auto;margin-bottom:0;}"]);
export default styles;